import React, { useState, useEffect } from 'react';
import { Dialog, BoxProps, Box, Grid, Button } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';

export interface IAddQuestionModal {
  open: boolean;
  onClose: () => void;
  question: string;
  updateDetails: (markdown: string) => void;
}

const containerStyles: BoxProps['sx'] = {
  backgroundColor: 'background.default',
  p: '15px',
  minWidth: { xs: 'unset', sm: '90vw' },
};

const editorContainerStyles: React.CSSProperties = {
  overflowY: 'auto',
  maxHeight: '60vh',
  marginTop: '15px',
  marginBottom: '15px',
};

const buttonContainer: React.CSSProperties = {
  borderTop: '1px solid lightgray',
  paddingTop: '15px',
};

const AddQuestionModal: React.FC<IAddQuestionModal> = ({
  open,
  onClose,
  question,
  updateDetails,
}) => {
  const [value, setValue] = useState(question);

  useEffect(() => {
    setValue(question);
  }, [question]);

  const handleSubmit = () => {
    console.log('Value', value);
    updateDetails(value);
  };

  const onChange = (val) => {
    setValue(val);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: { xs: '95vw' }, m: '0' },
      }}
    >
      <Box role="presentation" sx={containerStyles}>
        <div style={editorContainerStyles}>
          <MDEditor value={value} onChange={onChange} />
        </div>

        <Box style={buttonContainer}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="flex-end"
          >
            <Grid item>
              <Button variant="contained" color="secondary" onClick={onClose}>
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                disabled={value.trim().length === 0}
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Okay
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Dialog>
  );
};

export default AddQuestionModal;
